import axios, { clientContext } from './config'

const apiStyleProfile = {
  getStyleProfile () {
    return axios.get(`/api/styleprofiles/${clientContext.getStyleProfileId()}/`)
  },
  patchStyleProfile (data) {
    return axios.patch(`/api/styleprofiles/${clientContext.getStyleProfileId()}/`, data)
  },
  getStyleProfileOptions () {
    return axios.get('/api/styleprofiles/options/')
  },
  getSignUpStyleColors () {
    return axios.get('/api/stylecolors/style_quiz/')
  }
}

export default apiStyleProfile
